export const getClampedPercent = (value: number): number =>
  Math.min(Math.max(value, 0), 100);
